import { useCallback, useContext, useEffect } from 'react';
import { useEditContext } from 'react-admin';

import { AppContext } from '@app/contexts';
import { FIELD_TYPES, validateFormFields } from '@app/utils/validateUtils';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';
import EditView from '@app/components/common/views/EditView';

import { EditUserForm } from './EditUserForm';

const formFields = [
  { key: 'name', type: FIELD_TYPES.MULTILINGUAL, message: 'Name is required' },
  { key: 'role', type: FIELD_TYPES.SELECT, message: 'Role is required' },
  { key: 'email', type: FIELD_TYPES.EMAIL, message: 'Email is not valid' },
];

export const EditUser = () => {
  const { handleChangeLoading } = useContext(AppContext);
  const validate = useCallback(
    (values: GenericObject) => validateFormFields({ fields: formFields, values, image: undefined }),
    []
  );
  const { saving } = useEditContext();

  useEffect(() => {
    handleChangeLoading(!!saving);
  }, [saving, handleChangeLoading]);

  return (
    <div>
      <EditView
        transform={undefined}
        hideDelete={true}
        resourceSingular="user"
        validate={validate}
        mutationMode="pessimistic">
        <EditUserForm />
      </EditView>
    </div>
  );
};
